"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeFields = exports.NodeTitle = void 0;
const Colors_1 = require("../../Colors");
const theme_1 = require("../../editor/theme");
const NodeName = {
    marginRight: 10,
    color: Colors_1.Colors.grey[0],
    fontSize: 12,
    padding: `5px 0 5px 10px`,
    userSelect: 'none',
    '-moz-user-select': '-moz-none',
};
const NodeType = {
    color: Colors_1.Colors.main[0],
    fontSize: 10,
    marginRight: 'auto',
    padding: `5px 30px 5px 0`,
};
const NodeIconArea = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    width: 24,
    height: 24,
    transition: 'background 0.25s ease-in-out',
    background: 'transparent',
    cursor: 'pointer',
    borderRadius: 12,
    $nest: {
        '&:hover': {
            background: '#0003',
        },
    },
};
exports.NodeTitle = {
    background: Colors_1.Colors.grey[8],
    display: 'flex',
    alignItems: 'stretch',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    padding: 5,
    $nest: {
        '.NodeName': NodeName,
        '.NodeType': NodeType,
        '.NodeIconArea': NodeIconArea,
    },
};
exports.NodeFields = Object.assign({ borderBottomLeftRadius: 4, borderBottomRightRadius: 4, background: Colors_1.Colors.grey[8] }, Object.keys(theme_1.GraphQLBackgrounds).reduce((a, b) => {
    a[`.NodeBackground-${b}`] = {
        background: theme_1.GraphQLBackgrounds[b],
    };
    return a;
}, {}));
